const ListTable = require('app/ui/list/Table');
const GraphQLMutation = require('app/graphql/Mutation');


class PendingTab {
    defaultOptions() {
        return {
            '$container': $('<div/>'),
            'view': null,
            'length': 100,
        };
    }

    constructor(options) {
        this.settings = $.extend(this.defaultOptions(), options);

        this.onSubmitFilterForm = this.onSubmitFilterForm.bind(this);
        this.buildGraphQLParameters = this.buildGraphQLParameters.bind(this);

        this.$container = this.settings.$container;
        if(this.$container.length <= 0){
            window.notify("Can't find container view with selector " + this.settings.selector,'danger');
        }

        this.view = this.settings.view;
        if(!this.view){
            window.notify("Missing view parameter","danger");
        }

        this.initialize();
    }

    initialize() {
        var self = this;

        this.buildTab();
    }

    onDOMReady(){
    }

    buildTab(){

        this.$tableContainer = $('<div/>')
        .addClass('product-price-pending-list-container')
        .append(window.App.generateLoader());

        this.$filterForm = this.view.buildFilterForm(this.onSubmitFilterForm);
        this.$filterRange = $('select[name="range"]',this.$filterForm); 
        this.$filterByNumber = $('input[name="number"]',this.$filterForm);
        this.$filterByReference = $('input[name="reference"]',this.$filterForm);
        this.$filterByRange = $('select[name="range"]',this.$filterForm);
        this.$filterBySupplier = $('select[name="supplier"]',this.$filterForm);

        this.$content = $('<div/>')
        .addClass('row')
        .append(
            $('<div/>')
            .addClass('col-9 p-2')
            .append(
                $('<div/>')
                .addClass('white-box')
                .append(this.$tableContainer)
            )
        )
        .append(
            $('<div/>')
            .addClass('col-3 p-2')
            .append(
                $('<div/>')
                .addClass('white-box')
                .append(
                    $('<h3/>')
                    .addClass('box-title')
                    .append(window.translate('app.product.search.label'))
                )
                .append(this.$filterForm)
            )
        )

        this.$container
        .html('')
        .append(this.$content);

        this.initializeListTable();

        this.onDOMReady();
    }

    buildGraphQLParameters(){
        let filters = {
        };

        if(this.$filterByNumber && this.$filterByNumber.val()){
            filters.number = this.$filterByNumber.val();
        }

        if(this.$filterByReference && this.$filterByReference.val()){
            filters.reference = '%'+this.$filterByReference.val()+'%';
        }

        if(this.$filterByRange && parseInt(this.$filterByRange.val())){
            filters.rootRange = parseInt(this.$filterByRange.val());
        }

        if(this.$filterBySupplier && parseInt(this.$filterBySupplier.val())){
            filters.supplier = parseInt(this.$filterBySupplier.val());
        }

        let orderBy = 'reference';
        let dir = "ASC";
        let parameters = {
            'filter' : filters,

            'orderBy': orderBy,
            'dir': dir,
        };

        return parameters;
    }

    onSubmitFilterForm(event){
        this.table.refresh();
    }

    refresh(){
        this.table.refresh();
    }

    buildRowId(item){
        return 'productPricePending'+item.product.id;
    }

    initializeListTable(){
        var self = this;

        let fields = [
            'product { id number reference price supplier { id name rfa } }',
            'date',
            'supplierPrice',
            'supplierPriceViewable',
            'price',
        ];

        this.table = new ListTable({
            '$container': this.$tableContainer,
            'tableClass': 'table table-striped product-price-pending-list',
            'id': 'list-products',
            'length': this.settings.length,
            'rowIdCallback': function(item){
                return self.buildRowId(item.node);
            },
            'graphQL': {
                'queryType': 'supplierProductPriceUpdatePendings',
                'fields': fields,
                'parameters': this.buildGraphQLParameters,

            },
            'columns': [
                {
                    'name': 'number',
                    'label': window.translate('product.price.pending.number.label'),
                    'class': 'product-number',
                    'render': function(item,index){
                        return item.node.product.number;
                    },
                },
                {
                    'name': 'reference',
                    'label': window.translate('product.price.pending.reference.label'),
                    'class': 'product-reference',
                    'render': function(item,index){
                        return item.node.product.reference;
                    },
                },
                {
                    'name': 'supplier',
                    'label': window.translate('product.price.pending.supplier.label'),
                    'class': 'product-supplier',
                    'render': function(item,index){
                        return item.node.product.supplier.name;
                    },
                },
                {
                    'name': 'date',
                    'label': window.translate('product.price.pending.date.label'),
                    'class': 'product-price-pending-date',
                    'render': function(item,index){
                        return window.formatDate(item.node.date,window.translate('momentDateFormat.fullDay'));
                    },
                },
                {
                    'name': 'supplierPrice',
                    'label': window.translate('product.price.pending.supplierPrice.label'),
                    'class': 'product-price-pending-supplierPrice',
                    'render': function(item,index){
                        let $content = $('<div/>');

                        let supplierPrice = item.node.supplierPrice;
                        if(!supplierPrice){
                            supplierPrice = '';
                        }
                        let $input = $('<input/>')
                        .addClass("form-control form-control-sm")
                        .attr('type','text')
                        .attr('name','supplierPrice')
                        .val(supplierPrice)
                        .on('change',function(){
                            self.onChangeSupplierPrice(item.node,$content);
                        });

                        let rfa = item.node.product.supplier.rfa ? item.node.product.supplier.rfa : 0;
                        let discount = item.node.supplierPrice- (item.node.supplierPrice * (rfa / 100));
                        let $discount = $('<small/>')
                        .addClass('discount text-muted')
                        .append(window.translate('discount'))
                        .append(' : ')
                        .append(window.formatFloat(discount)+' &euro;');

                        $content
                        .append($input)
                        .append(
                            $('<div/>')
                            .append($discount)
                        );

                        return $content;
                    }
                },
                {
                    'name': 'supplierPriceViewable',
                    'label': window.translate('product.price.pending.supplierPriceViewable.label'),
                    'class': 'product-price-pending-supplierPriceViewable',
                    'render': function(item,index){
                        let $content = $('<div/>');

                        let supplierPriceViewable = item.node.supplierPriceViewable;
                        if(!supplierPriceViewable){
                            supplierPriceViewable = '';
                        }
                        let $input = $('<input/>')
                        .addClass("form-control form-control-sm")
                        .attr('type','text')
                        .attr('name','supplierPriceViewable')
                        .val(supplierPriceViewable)
                        .on('change',function(){
                            self.onChangeSupplierPriceViewable(item.node,$content);
                        });

                        let margin = ((item.node.supplierPriceViewable - item.node.supplierPrice) / item.node.supplierPrice) * 100;
                        if(item.node.supplierPrice ||!isFinite(margin)){
                            margin = 0;
                        }
                        let $margin = $('<small/>')
                        .addClass('margin text-muted')
                        .append(window.translate('margin'))
                        .append(' : ')
                        .append(window.formatFloat(margin)+' %');

                        $content
                        .append($input)
                        .append(
                            $('<div/>')
                            .append($margin)
                        );

                        return $content;
                    }
                },
                {
                    'name': 'price',
                    'label': window.translate('product.price.pending.price.label'),
                    'class': 'product-price-pending-price',
                    'render': function(item,index){
                        let $content = $('<div/>');

                        let price = item.node.price;
                        if(!price){
                            price = '';
                        }
                        let $input = $('<input/>')
                        .addClass("form-control form-control-sm")
                        .attr('type','text')
                        .attr('name','price')
                        .val(price)
                        .on('change',function(){
                            self.onChangePrice(item.node,$content);
                        });

                        if(!price){
                            price = item.node.product.price;
                        }
                        let margin = ((price - item.node.supplierPrice) / item.node.supplierPrice) * 100;
                        if(item.node.supplierPrice || !isFinite(margin)){
                            margin = 0;
                        }
                        let $margin = $('<small/>')
                        .addClass('margin text-muted')
                        .append(window.translate('margin'))
                        .append(' : ')
                        .append(window.formatFloat(margin)+' %');

                        $content
                        .append($input)
                        .append(
                            $('<div/>')
                            .append($margin)
                        );

                        return $content;
                    }
                },
                {
                    'name': 'actions',
                    'label': '',
                    'class': 'product-price-pending-actions',
                    'render': function(item,index){

                        let $btnDelete = $('<button/>')
                        .addClass('btn btn-sm btn-danger')
                        .append(
                            $('<i/>')
                            .addClass("fas fa-times")
                        )
                        .on("click",function(event){
                            self.onClickDelete(item.node);
                        })

                        return $btnDelete;
                    }
                }

            ]
        })
    }

    onChangeSupplierPrice(item,$cellContent){
        let value = parseFloat($('input[name="supplierPrice"]',$cellContent).val());
        this.submitChange(item,'supplierPrice',value,$cellContent.parent());
    }

    onChangeSupplierPriceViewable(item,$cellContent){
        let value = parseFloat($('input[name="supplierPriceViewable"]',$cellContent).val());
        this.submitChange(item,'supplierPriceViewable',value,$cellContent.parent());
    }

    onChangePrice(item,$cellContent){
        let value = parseFloat($('input[name="price"]',$cellContent).val());
        this.submitChange(item,'price',value,$cellContent.parent());
    }

    onClickDelete(item){
        this.submitDelete(item);
    }

    setErrorCell($cell){
        $cell
        .addClass('bg-danger');
        $('.text-muted',$cell)
        .removeClass('text-muted')
        .addClass('text-white');
    }

    submitChange(item,field,value,$cell){
        var self = this;
        let fields = [
            'success',
            'message',
            'errors { key, value }',
        ];
        let variables = {
            'product': {
                'value': item.product.id,
                'type': 'Int!'
            }
        };
        if(field == 'status'){
            variables[field] = {
                'value': parseInt(value),
                'type': 'Int',
            };
        }else{
            variables[field] = {
                'value': parseFloat(value),
                'type': 'Float',
            };
        }
        let mutation = new GraphQLMutation({
            //Mutation parameters
            'mutationType': "SubmitSupplierProductPriceUpdatePending",
            'fields': fields,
            'variables': variables,//format: {NAME:{'type':TYPE, 'value': VALUE}}

            //callbacks
            'before': function(){
            },
            'success': function(data){
                if(data.success){
                    window.notify(data.message,"success");
                    self.refresh(function(){
                        self.table.focus(self.buildRowId(item));
                    });
                }else{
                    self.setErrorCell($cell);
                }
            },
            'error': function(message, xhr){
                self.setErrorCell($cell);
            },
            'after': function(){
            }
        });
        mutation.execute();
    }


    submitDelete(item){
        var self = this;
        let fields = [
            'success',
            'message',
            'errors { key, value }',
        ];
        let variables = {
            'product': {
                'value': item.product.id,
                'type': 'Int!'
            }
        };
        let mutation = new GraphQLMutation({
            //Mutation parameters
            'mutationType': "DeleteSupplierProductPriceUpdatePending",
            'fields': fields,
            'variables': variables,//format: {NAME:{'type':TYPE, 'value': VALUE}}

            //callbacks
            'before': function(){
            },
            'success': function(data){
                if(data.success){
                    window.notify(data.message,"success");
                    self.refresh();
                }else{
                    window.notify(data.message,"error");
                }
            },
            'error': function(message, xhr){
                window.notify(message,"error");
            },
            'after': function(){
            }
        });
        mutation.execute();
    }

}

module.exports = PendingTab;

